import React from "react";
import PropTypes from "prop-types";
import { Font } from "../../Fonts/Font";
import "./Subcategory.scss";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../../redux/action";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../data";
export const SubCategoryMenu = ({ parent, menu, ...props }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const subMenuData = useSelector((el) => el?.productMeta?.data?.categories);
  let slug2;
  menu?.forEach((element) => {
    slug2 = parent?.find((el) => element.parent === el.id);
    return slug2;
  });
  const handleClick = (slug, parentSlug, grandParentSlug) => {
    if (!slug) return;
    dispatch(userActions.getCategory(slug));
    let route = grandParentSlug
      ? ROUTES.CATEGORY +
        "/" +
        grandParentSlug.replace(/\s/g, "") +
        "/" +
        parentSlug.replace(/\s/g, "") +
        "/" +
        slug.replace(/\s/g, "")
      : parentSlug
      ? ROUTES.CATEGORY +
        "/" +
        parentSlug.replace(/\s/g, "") +
        "/" +
        slug.replace(/\s/g, "")
      : ROUTES.CATEGORY + "/" + slug;
    navigate(route);
  };

  return (
    <div
      className="es-custom-sub-category"
      style={{ backgroundColor: "white" }}
    >
      {menu?.map((menuObject, i) => {
        return (
          <div className="sub_category_list" key={i}>
            <Font
              label={menuObject.name}
              color="#292929"
              size="16"
              weight="400"
              clickable
              onClick={() => handleClick(menuObject.slug || menuObject.id, slug2?.name)}
            />
            {subMenuData
              ?.filter((el) => el.parent === menuObject.id)
              ?.map((menu, j) => (
                <Font
                  label={menu.name}
                  color="#969595"
                  clickable={true}
                  size="16"
                  weight="400"
                  key={j}
                  onClick={() =>
                    handleClick(menu.slug || menu.id, menuObject.slug || menuObject.id, slug2?.name)
                  }
                />
              ))}
          </div>
        );
      })}
    </div>
  );
};

SubCategoryMenu.propTypes = {
  menu: PropTypes.array.isRequired,
};
SubCategoryMenu.defaultProps = {
  menu: [
    {
      title: "Food Cupboard",
      menu: [
        "Rice",
        "Yam",
        "Cassava Flour",
        "Beans",
        "Poundo Yam",
        "Yam Flour",
      ],
    },
    {
      title: "Fruits",
      menu: ["Grape", "Apple", "Peer", "Orange", "Pineapple", "Apple"],
    },
    {
      title: "Household Cleaning",
      menu: [
        "Laundry",
        "Air Fresher",
        "Dishwashing",
        "Bathroom Cleaners",
        "Toilet Papers & Wipe",
        "Disinfectant Wipe",
      ],
    },
    {
      title: "Beer, Wine & Spirit",
      menu: ["Beer", "Vodka", "Red wine", "Whiskey", "Liquors", "Champaigne"],
    },
  ],
};
